/**
 * Är mötet "mitt" — deltar jag, eller har jag skapat det?
 *
 * BK och IA som är tilldelade projektet får alla projektets möten från
 * backend (getMeetingsByProject), eftersom protokollen bara nås via mötet.
 * Möten-vyn visar ändå bara de egna som förval, och bara på de egna kan man
 * skriva anteckningar och ändra mötet. Andras möten är till för att läsa
 * protokollet.
 *
 * Admin räknas alltid som deltagare — admin har haft full åtkomst förut.
 */
const idAv = (v) => (v && typeof v === 'object' ? v._id : v)?.toString?.();

export const arMittMote = (meeting, user) => {
  if (!meeting || !user) return false;
  if (user.role === 'admin') return true;
  const minId = user._id?.toString();
  if (idAv(meeting.createdBy) === minId) return true;
  return (meeting.attendees || []).some(a =>
    idAv(a.userId) === minId || (a.email && a.email === user.email)
  );
};

// Roller som får välja mellan "Mina möten" och "Alla" — de som ser alla
// projektets möten.
export const SER_ALLA_MOTEN = ['byggkonsult', 'inredningsarkitekt', 'admin'];
